
const { default: axios } = require("axios");
import { createApp } from 'vue';
import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/css';

var gap = document.getElementById("gap").clientWidth;
var gap2x = document.getElementById("gap-2x").clientWidth;
var mVert = document.getElementById("m-vert").clientWidth;
var mVertSlim = document.getElementById("m-vert-slim").clientWidth;
var widthMargin = document.getElementById("width-margin").clientWidth;
var articleWidth = document.getElementById("article-width").clientWidth;

var ff = 0;

window.addEventListener('load',function() {
    
    const ff = createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                waitForApi: false,
                hit: hit,
                // UI
                simpleMode: false,
                shortVideos: false,
                showDebug: false,
                screen: 'home',
                swipers: [],
                currentModule: 0,
                currentQuest: 1,
                currentQuests: 1,
                showCharacter: false,   
                showBadges: false,
                showNewBadges: [],
                showNewBadgesAnimate: false,
                showPopIn: false,
                debug: typeof characterDefault!='undefined',
                anyVideoEnded: 0, // just to trigger a re-render
                xp: 0,
                showMap: true,
                pillars: [ 'VALUES', 'BODY', 'SOCIAL', 'WORK', 'MONEY' ],
                pillarsLabels: {
                    'VALUES': {
                        key: 'VALUES',
                        title: 'Werte und Überzeugungen'
                    },
                    'BODY': {
                        key: 'BODY',
                        title: 'Körper und Gesundheit'
                    },
                    'SOCIAL': {
                        key: 'SOCIAL',
                        title: 'Soziale Beziehungen'
                    },
                    'WORK': {
                        key: 'WORK',
                        title: 'Arbeit und Leistung'
                    },  
                    'MONEY': {
                        key: 'MONEY',
                        title: 'Materialle Sicherheit'
                    },

                },
                attributes: [ 'COURAGE', 'WISDOM', 'FOCUS', 'FRIEND' ],
                attributesLevels: ["","Bronze","Silber","Gold"],
                attributesGoals: [20,25,75],
                attributesLabels: {
                    'COURAGE': {
                        key: 'COURAGE',
                        title: 'Stärke',
                        threshold: [1,2,3]
                    },
                    'WISDOM': {
                        key: 'WISDOM',
                        title: 'Weisheit',
                        threshold: [1,2,3]
                    },
                    'FRIEND': {
                        key: 'FRIEND',
                        title: 'Buddy',
                        threshold: [1,2,3]
                    },
                    'FOCUS': {
                        key: 'FOCUS',
                        title: 'Fokus',
                        threshold: [1,2,3]
                    }
                },
                badges: {
                    FIRSTQUEST: {
                        key: 'FIRSTQUEST',
                        title: 'Erste Quest',
                        description: 'Großartig. Du hast die erste Quest bestanden',
                        xp: 100
                    },
                    EGGHEAD: {
                        key: 'EGGHEAD',
                        title: 'Schlau&shy;meier',
                        description: 'Deine erste richtige Antwort!',
                        xp: 100
                    }
                },
                // User
                badgesReceived: [],
                characterAttributesLevels: [0,1,2,3],
                characterName: typeof characterDefault!='undefined'?characterDefault:'',
                xp: 0,
                scores: {
                },
                answers: {}
            }
        },
        methods: {
            storeInLocalStorage: function() {
                localStorage.setItem('hero-in-training',JSON.stringify({
                    characterName: this.characterName,
                    xp: this.xp,
                    scores: this.scores,
                    answers: this.answers,
                    module: this.currentModule,
                    badgesReceived: this.badgesReceived,
                }));
            },
            loadFromLocalStorage: function() {
                var stored = localStorage.getItem('hero-in-training');
                if(stored) {
                    stored = JSON.parse(stored);
                    this.characterName = stored.characterName;
                    this.xp = stored.xp;
                    this.scores = stored.scores;
                    this.answers = stored.answers;
                    this.currentModule = stored.module?stored.module:0;
                    this.badgesReceived = stored.badgesReceived;
                    this.goScreen('game');
                    this.showTheMap();
                }
            },
            resetTheGame: function() {
                this.characterName = '';
                this.xp = 0;
                this.scores = {};
                this.answers = {};
                this.badgesReceived = [];
                this.showCharacter = false;
                this.showBadges = false;
                this.showNewBadges = [];
                this.showNewBadgesAnimate = false;
                this.showPopIn = false;
                this.anyVideoEnded = 0;
                this.showMap = true;
                this.currentModule = 1;
                this.currentQuest = 1;
                this.currentQuests = 1;
                this.showDebug = false;
                this.swipers = [];
                this.simpleMode = false;
                this.shortVideos = false;
                this.debug = characterDefault!='undefined';
                this.storeInLocalStorage();
                this.goScreen('home');
            },
            toggleSimpleMode: function() {
                this.simpleMode = !this.simpleMode;
            },
            toggleShortVideos: function() {
                this.shortVideos = !this.shortVideos;
            },
            goScreen: function(screen) {
                this.screen = screen;
            },
            startGame: function() {
                this.goScreen('game');
                window.setTimeout(function() {
                    this.showModule(this.currentModule);
                    this.setModuleOnMap();
                }.bind(this),246);
            },
            checkName: function(thenGo) {
                if(this.characterName.length >= 5) {
                    if(thenGo == 'game') {
                        this.startGame();
                    } else {
                        this.goScreen(thenGo);
                    }
                } else {
                    alert("Bitte gib einen Namen mit mindestens 5 Zeichen ein.");
                }
            },
            showTheMap: function() {
                this.showMap = true;
                window.setTimeout(function() {
                    this.setModuleOnMap();
                }.bind(this),1000);
            },
            hideTheMap: function() {
                this.showMap = false
            },
            setModuleOnMap: function() {
                let id = 'module__map_module_'+this.currentModule;
                let currentModuleElement = document.getElementById(id); 
                if(currentModuleElement) {
                    let svgInElement = currentModuleElement.querySelector('svg');
                    let coords = svgInElement.getBoundingClientRect();
                    let appElement = document.getElementById('map_modules');
                    let appCoords = appElement.getBoundingClientRect();
                    let x = coords.left - appCoords.left + coords.width/2;
                    let y = coords.top - appCoords.top;
                    let figure = document.getElementById('mapHero');
                    let svgInHero = figure.querySelector('svg');
                    figure.style.left = x + 'px';
                    figure.style.top = (y+0) + 'px';
                    figure.style.display = 'block';
                    svgInHero.classList.add('jump');
                    window.setTimeout(function() {
                        svgInHero.classList.remove('jump');
                    },1000);
                }
            },
            mapWave: function(i) {
                const wayPointsX = [
                    '20%', '30%', '-40%', '-30%', '-82%', '-10%', '-82%', '-10%', '-120%', '50%', '50%', '50%', '50%', '50%'
                ];
                if(!this.hit.length) {
                    return 0;
                }
                this.hit[1].finished = true;
                console.log('mapWave',i,wayPointsX[i]);
                return wayPointsX[i]?wayPointsX[i].replace('%','')*(1):0;
            },
            isCurrentModule: function(idx) {
                return this.currentModule == idx;
            },
            toggleCharacterSheet: function() {
                this.showCharacter = !this.showCharacter;
            },
            toggleBadges: function() {
                this.showBadges = !this.showBadges;
            },
            showModule: function(index, questIndex) {
                this.currentModule = index;
                this.currentQuest = 1;
                this.showDebug = false;
                if(typeof questIndex != 'undefined') {
                    this.currentQuest = questIndex;
                }
                console.log('showModule',index,questIndex);
                window.setTimeout(function() {
                    var modEl = document.querySelector('#module'+index);
                    if( modEl ) {
                        this.swipers[this.currentModule] = new Swiper(modEl.querySelector('.swiper-container'),{
                            modules: [Navigation,Pagination],
                            loop: false,
                            supportsTouch: false,
                            allowTouchMove	: false,
                            on: {
                                slideChange: function() {
                                    ff.currentQuest = this.activeIndex + 1;
                                },
                                init: function() {
                                    this.slideTo(ff.currentQuest - 1);
                                }
                            },
                            navigation: {
                                prevEl: modEl.querySelector('.prev.button'),
                                nextEl: modEl.querySelector('.next.button')
                            },
                            pagination: {
                                el: modEl.querySelector('.swiper-pagination'),
                                type: 'bullets',
                                clickable: true
                            }
                        });
                        if(questIndex && this.debug) {
                            this.showMap = false;
                            this.swipers[this.currentModule].slideTo(questIndex-1);
                            return;
                        }
                        var firstUnanswered = false;
                        this.hit[index].quests.map(function(quest,questIndex) {
                            if( quest.type != "RESULT" && quest.type != "LINK" && quest.type != "FILE" && quest.type != "RANGE") {
                                if(quest.type != "INFO") {
                                    if(typeof this.answers[index+"_"+questIndex] == 'undefined' && firstUnanswered === false) {
                                        firstUnanswered = questIndex+1;
                                    }
                                }
                            }
                        }.bind(this));
                        if(firstUnanswered!==false) {
                            this.currentQuest = firstUnanswered;
                            this.swipers[this.currentModule].slideTo(firstUnanswered-1);
                        } else {
                            this.currentQuest = 1;
                        }
                    }
                }.bind(this),246);
            },
            videoEnded: function(moduleIndex,questIndex) {
                this.anyVideoEnded = 1;
                this.$forceUpdate();
            },
            slidePrev: function() {
                this.reCalcScores();
                if(this.currentQuest > 1) {
                    this.swipers[this.currentModule].slidePrev();
                } else {
                    this.showTheMap();
                }
            },
            slideNext: function() {
                this.reCalcScores();
                var canSwipe = true;
                console.log(this.currentQuest);
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == 'LINK') {
                    if(typeof this.answers[this.currentModule+"_"+(this.currentQuest-1)] == 'undefined') {
                        alert("Bitte öffne den Link.");
                        canSwipe = false;
                    } else {
                        this.handOverBagde(this.hit[this.currentModule].quests[this.currentQuest-1].badge);
                    }
                }
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == 'FILE') {
                    if(typeof this.answers[this.currentModule+"_"+(this.currentQuest-1)] == 'undefined') {
                        alert("Bitte lade das File herunter.");
                        canSwipe = false;
                    } else {
                        this.handOverBagde(this.hit[this.currentModule].quests[this.currentQuest-1].badge);
                    }
                }
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == 'MC') {
                    if(typeof this.answers[this.currentModule+"_"+(this.currentQuest-1)] == 'undefined') {
                        alert("Bitte wähle eine Antwort aus.");
                        canSwipe = false;
                    } else {
                        if(this.answers[this.currentModule+"_"+(this.currentQuest-1)] == 0) {
                            this.handOverBagde('EGGHEAD');
                        }
                    }
                }
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == 'MCFREE') {
                    if(typeof this.answers[this.currentModule+"_"+(this.currentQuest-1)] == 'undefined') {
                        alert("Bitte wähle mindestens eine Antwort aus.");
                        canSwipe = false;
                    } else {
                        this.handOverBagde(this.hit[this.currentModule].quests[this.currentQuest-1].badge);
                    }
                }
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == 'TEXT') {
                    if(typeof this.answers[this.currentModule+"_"+(this.currentQuest-1)] == 'undefined' || this.answers[this.currentModule+"_"+(this.currentQuest-1)].trim() == '') {
                        alert("Bitte gib eine Antwort ein.");
                        canSwipe = false;
                    } else {
                        this.handOverBagde(this.hit[this.currentModule].quests[this.currentQuest-1].badge);
                    }
                }
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == 'SHARE') {
                    if(typeof this.answers[this.currentModule+"_"+(this.currentQuest-1)] == 'undefined' || this.answers[this.currentModule+"_"+(this.currentQuest-1)].trim() == '') {
                        alert("Bitte teile deine Antwort.");
                        canSwipe = false;
                    } else {
                        this.handOverBagde(this.hit[this.currentModule].quests[this.currentQuest-1].badge);
                    }
                }
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == 'VIDEO') {
                    if(this.answers[this.currentModule+"_"+(this.currentQuest-1)] != "1" ) {
                        var videoIsFinished = document.getElementById('fs_video_'+this.currentModule+"_"+(this.currentQuest-1));
                        if(!videoIsFinished.ended && !this.simpleMode && !this.shortVideos) {
                            alert("Bitte schaue das Video zu Ende.");
                            canSwipe = false;
                        } else {
                            this.answers[this.currentModule+"_"+(this.currentQuest-1)] = "1";
                            this.handOverBagde(this.hit[this.currentModule].quests[this.currentQuest-1].badge);
                        }
                    }
                };
                if(this.hit[this.currentModule].quests[this.currentQuest-1].type == '_AUDIO') {
                    var audioIsFinished = document.getElementById('audio_'+this.currentModule+"_"+(this.currentQuest-1));
                    if(!audioIsFinished.ended) {
                        alert("Bitte hör dir das Audio zu Ende an.");
                        canSwipe = false;
                    } else {
                        this.answers[this.currentModule+"_"+(this.currentQuest-1)] = "1";
                        this.handOverBagde(this.hit[this.currentModule].quests[this.currentQuest-1].badge);
                    }
                };
                this.storeInLocalStorage();
                if(canSwipe) {
                    if(this.currentQuest < this.hit[this.currentModule].quests.length && !this.simpleMode) {
                        this.swipers[this.currentModule].slideNext();
                    } else {
                        this.finishModule();
                    }
                }
            },
            attributeHighestPossible: function(key) {
                var highestPossible = 0;
                this.hit.map(function(module) {
                    module.quests.map(function(quest) {
                        var points = quest.points.split(";");
                        if(points[0] == key) {
                            highestPossible += points[1]*1;
                        }
                        quest.answers.map(function(a) {
                            if(a.points.split(";")[0] == key) {
                                if(a.points.split(";")[1]) {
                                    highestPossible += a.points.split(";")[1]*1;
                                } else {
                                    highestPossible += 10;
                                }
                            }
                        });
                    });
                });
                return highestPossible;
            },
            attributePercent: function(key) {
                if(this.attributeHighestPossible(key)) {
                    return Math.round(this.scores[key] / this.attributeHighestPossible(key) * 100);
                }
                return 0;
            },
            scorePercent: function(value) {
                var highestScore = 0;
                for(var key in this.scores) {
                    if(this.scores[key] > highestScore && key != "XP") {
                        highestScore = this.scores[key];
                    }
                };
                highestScore *= this.hit.length-this.currentModule;
                if(value) {
                    return Math.round(value / highestScore * 100);
                }
                return 0;
            },
            playVideo(elementId) {
                console.log("play",elementId);
                var video = document.getElementById("fs_"+elementId);
                video.classList.add('playing');
                console.log(video,video.classList);
                video.play();
            },
            pauseVideo(elementId) {
                console.log("pause",elementId);
                var video = document.getElementById("fs_"+elementId);
                console.log(video);
                video.classList.remove('playing');
                video.pause();
            },
            toggleAudio(elementId) {
                var audio = document.getElementById(elementId).querySelector('audio');
                if(audio.paused) {
                    audio.play();
                    audio.classList.add('playing');
                } else {
                    audio.classList.remove('playing');
                    audio.pause();
                }
            },
            pauseAudio(elementId) {
                var audio = document.getElementById(elementId).querySelector('audio');
                audio.classList.remove('playing');
                audio.pause();
            },
            shuffleAnswers: function(answers) {
                this.hit.map(function(module) {
                    module.quests.map(function(quest) {
                        if(quest.type == 'MC') {
                            quest.answers.map(function(a,index) {
                                if(typeof a.index == 'undefined') {
                                    a.index = index;
                                }
                            });
                            quest.answers.sort(() => Math.random() - 0.5);
                        }
                    });
                });
            },
            parseBody: function(text) {
                // search for {x} and replace {x} with the answer from that quest
                var matches = text.match(/{\d+}/g);
                if(matches) {
                    matches.map(function(match) {
                        var questId = match.replace(/{|}/g,'');
                        var answer = false;
                        this.hit.forEach(function(module,moduleIndex) {
                            module.quests.forEach(function(quest,questIndex) {
                                if(questId == quest.id) {
                                    if(typeof this.answers[moduleIndex+"_"+questIndex] != 'undefined') {
                                        answer = this.answers[moduleIndex+"_"+questIndex];
                                    }
                                }
                            }.bind(this));
                        }.bind(this));
                        if(answer) {
                            text = text.replace(match,answer);
                        }
                    }.bind(this));
                }
                return text;
            },
            setDOCAnswer: function(moduleIndex,questIndex,answerIndex) {
                if(typeof this.answers[moduleIndex+"_"+questIndex] == 'undefined') {
                    this.answers[moduleIndex+"_"+questIndex] = true;
                    this.xp += this.hit[moduleIndex].quests[questIndex].answers[answerIndex].xp*1;
                }
            },
            setMCAnswer: function(moduleIndex,questIndex,answerIndex) {
                if(typeof this.answers[moduleIndex+"_"+questIndex] == 'undefined') {
                    this.answers[moduleIndex+"_"+questIndex] = answerIndex;
                    this.xp += this.hit[moduleIndex].quests[questIndex].answers[answerIndex].xp*1;
                }
            },
            setMCFREEAnswer: function(moduleIndex,questIndex,answerIndex,maxAnswers) {
                if(maxAnswers == 1) {
                    this.answers[moduleIndex+"_"+questIndex] = [];
                }
                if(typeof this.answers[moduleIndex+"_"+questIndex] == 'undefined') {
                    this.answers[moduleIndex+"_"+questIndex] = [];
                }
                var currentAnswers = this.answers[moduleIndex+"_"+questIndex];
                if(!maxAnswers || currentAnswers.length < maxAnswers) {
                    if(currentAnswers.indexOf(answerIndex) == -1) {
                        currentAnswers.push(answerIndex);
                        this.xp += this.hit[moduleIndex].quests[questIndex].answers[answerIndex].xp*1;
                    } else {
                        currentAnswers.splice(currentAnswers.indexOf(answerIndex),1);
                        this.xp -= this.hit[moduleIndex].quests[questIndex].answers[answerIndex].xp*1;
                    }
                } else {
                    alert("Du kannst nur "+maxAnswers+" Antwort"+((maxAnswers>1)?'en':'')+" auswählen.");
                }
                this.answers[moduleIndex+"_"+questIndex] = currentAnswers;
            },
            setTEXTAnswer: function(moduleIndex,questIndex,id) {
                var textareaValue = document.getElementById("quest"+id).querySelector("textarea").value;
                if(textareaValue.trim() != '') {
                    this.answers[moduleIndex+"_"+questIndex] = textareaValue;
                    this.xp += this.hit[moduleIndex].quests[questIndex].xp*1;
                }
            },
            doSHAREAnswer: function(moduleIndex,questIndex,id) {
                var textareaValue = document.getElementById("quest"+id).querySelector("textarea").value;
                if(textareaValue.trim() != '') {
                    this.answers[moduleIndex+"_"+questIndex] = textareaValue;
                    this.xp += this.hit[moduleIndex].quests[questIndex].xp*1;
                } else {
                    alert("Bitte gib einen Text ein.");
                    return;
                }
                if(textareaValue.trim() != '') {
                    this.answers[moduleIndex+"_"+questIndex] = textareaValue;
                    this.xp += this.hit[moduleIndex].quests[questIndex].xp*1;
                }
                if (navigator.share) {
                    navigator.share({
                        title: 'Das wollte ich mit dir teilen:',
                        text: this.parseBody(textareaValue)
                    })  
                    .then(() => console.log('Share successful'))
                    .catch((error) => console.log('Error sharing:', error));
                } else {
                    navigator.clipboard.writeText(this.parseBody(textareaValue)).then(function() {
                        alert("Text in die Zwischenablage kopiert. Du kannst ihn jetzt teilen.");
                    }, function(err) {
                        console.error('Could not copy text: ', err);
                    });
                }
            },
            setRANGEAnswer: function(moduleIndex,questIndex,answerIndex,answerValue) {
                if( this.answers[moduleIndex+"_"+questIndex] == 'undefined') {
                    this.xp += this.hit[moduleIndex].quests[questIndex]+xp*1;
                }
                this.answers[moduleIndex+"_"+questIndex] = answerValue;
            },
            isCorrectAnswer: function(moduleIndex, questIndex, thisIndex) {
                if(!this.hit) {
                    return;
                }
                var answerGiven = this.answers[moduleIndex+"_"+questIndex];
                if(typeof answerGiven != 'undefined') {
                    if(thisIndex == 0) {
                        return "answered correct";
                    }
                    if(thisIndex == answerGiven) {
                        return "answered wrong";
                    }
                    return "answered";
                }
                return 'not-answered';
            },
            isMCFREESelected: function(moduleIndex, questIndex, thisIndex) {
                if(!this.hit) {
                    return;
                }
                var answersGiven = this.answers[moduleIndex+"_"+questIndex];
                if(typeof answersGiven != 'undefined') {
                    return answersGiven.indexOf(thisIndex) != -1;
                }
                return false;
            },
            isAnswered(moduleIndex, questIndex) {
                if(typeof this.answers[moduleIndex+"_"+questIndex] != 'undefined' || this.hit[moduleIndex].quests[questIndex].type == "INFO" || this.hit[moduleIndex].quests[questIndex].type == "RANGE" || this.hit[moduleIndex].quests[questIndex].type == "RESULT") {
                    return true;
                }
                return false;
            },
            allQuestsAnswered: function(moduleIndex) {
                var allAnswered = true;
                this.hit[moduleIndex].quests.map(function(quest,questIndex) {
                    if(quest.type == "INFO" || quest.type == "RESULT") {
                        return;
                    }
                    if(typeof this.answers[moduleIndex+"_"+questIndex] == 'undefined') {
                        allAnswered = false;
                    }
                }.bind(this));
                return allAnswered;
            },
            reCalcScores: function() {
                this.scores = [];
                var newXp = 0;
                this.hit.map(function(module,moduleIndex) {
                    module.quests.map(function(quest,questIndex) {
                        if(quest.type == 'VIDEO') {
                            var video = document.getElementById('fs_video_'+moduleIndex+"_"+questIndex);
                            if(!video) {
                                return;
                            }
                            var hasEnded = video.ended;
                            var didPlay = video.currentTime > 0;
                            var score = quest.points.split(";");
                            if(didPlay && hasEnded) {
                                if(typeof this.scores[score[0]] == 'undefined') {
                                    this.scores[score[0]] = score[1]*1;
                                } else {
                                    this.scores[score[0]] += score[1]*1;
                                }
                                newXp += quest.xp*1;
                            }
                        }
                        if(quest.type == 'AUDIO') {
                            var audio = document.getElementById('audio_'+moduleIndex+"_"+questIndex);
                            if(!audio) {
                                return;
                            }
                            var hasEnded = audio.ended;
                            var didPlay = audio.currentTime > 0;
                            var score = quest.points.split(";");
                            if(didPlay && hasEnded) {
                                if(typeof this.scores[score[0]] == 'undefined') {
                                    this.scores[score[0]] = score[1]*1;
                                } else {
                                    this.scores[score[0]] += score[1]*1;
                                }
                                newXp += quest.xp*1;
                            }
                        }
                        if(quest.type == 'MC') {
                            quest.answers.map(function(a,index) {
                                if(typeof this.answers[moduleIndex+"_"+questIndex] != 'undefined' && this.answers[moduleIndex+"_"+questIndex] == a.index) {
                                    var score = a.points.split(";");
                                    if(typeof this.scores[score[0]] == 'undefined') {
                                        this.scores[score[0]] = score[1]*1;
                                    } else {
                                        this.scores[score[0]] += score[1]*1;
                                    }
                                    newXp += a.xp*1;
                                }
                            }.bind(this));
                        }
                        if(quest.type == 'MCFREE') {
                            quest.answers.map(function(a,index) {
                                if(this.answers[moduleIndex+"_"+questIndex] && this.answers[moduleIndex+"_"+questIndex].indexOf(index) != -1) {
                                    var score = a.points.split(";");
                                    if(typeof this.scores[score[0]] == 'undefined') {
                                        this.scores[score[0]] = score[1]*1;
                                    } else {
                                        this.scores[score[0]] += score[1]*1;
                                    }
                                    newXp += a.xp*1;
                                }
                            }.bind(this));
                        }
                        if(quest.type == 'TEXT') {
                            quest.answers.map(function(a,index) {
                                if(this.answers[moduleIndex+"_"+questIndex] != '') {
                                    var score = quest.points.split(";");
                                    if(typeof this.scores[score[0]] == 'undefined') {
                                        this.scores[score[0]] = score[1]*1;
                                    } else {
                                        this.scores[score[0]] += score[1]*1;
                                    }
                                    newXp += quest.xp*1;
                                }
                            }.bind(this));
                        }
                        if(quest.type == 'RANGE') {
                            quest.answers.map(function(a,index) {
                                if(this.answers[moduleIndex+"_"+questIndex+"_"+index] != '') {
                                    var score = a.points.split(";");
                                    if(typeof this.scores[score[0]] == 'undefined') {
                                        this.scores[score[0]] = 0;
                                        if(this.answers[moduleIndex+"_"+questIndex+"_"+index]*1>0) {
                                            this.scores[score[0]] = score[1]?score[1]*1:(this.answers[moduleIndex+"_"+questIndex+"_"+index]?this.answers[moduleIndex+"_"+questIndex+"_"+index]*1:0);
                                        }
                                    } else {
                                        if(this.answers[moduleIndex+"_"+questIndex+"_"+index]*1>0) {
                                            this.scores[score[0]] += score[1]?score[1]*1:(this.answers[moduleIndex+"_"+questIndex+"_"+index]?this.answers[moduleIndex+"_"+questIndex+"_"+index]*1:0);
                                            newXp += a.xp*1;
                                        }
                                    }
                                }
                            }.bind(this));
                        }
                    }.bind(this));
                }.bind(this));
                this.xp = newXp;
                // Recalc badges
                var newLevels = this.characterAttributesLevels;
                for( var i = 0; i < newLevels.length; i++ ) {
                    for( var g = 0; g < this.attributesGoals.length; g++ ) {
                        if(this.attributePercent[this.attributes[i]] >= this.attributesGoals[g]) {
                            newLevels[i] = g;
                        }
                    }
                }
                this.characterAttributesLevels = newLevels;
            },
            selectModule: function(index) {
                if(index == -1 ) {
                    alert("Dies Modul steht noch nicht zur Verfügung.");
                    return;
                }
                if(index == 0 || this.moduleFinished(index-1)) {
                    this.currentModule = index;
                    this.setModuleOnMap();
                    
                } else {
                    alert("Bitte beende das vorherige Modul zuerst.");
                }
            },
            startModule: function() {
                this.showModule(this.currentModule);
                this.hideTheMap();
            },
            finishModule: function() {
                if(this.moduleFinished(this.currentModule)) {
                    this.handOverBagde('MODULE'+this.currentModule);
                    this.showMap = true;
                    this.currentModule++;
                } else {
                    alert("Bitte beantworte alle Fragen.");
                    this.showModule(this.currentModule);
                }
            },
            moduleFinished: function(moduleIndex) {
                var finished = true;
                if(moduleIndex < 0) {
                    return true;
                }
                this.hit[moduleIndex].quests.map(function(quest,questIndex) {
                    console.log(quest,questIndex);
                    if(quest.type == "INFO" || quest.type == "RESULT" || quest.type == "RANGE") {
                        return;
                    }
                    if(this.simpleMode && questIndex > 0 ) {
                        return;
                    }
                    if(typeof this.answers[moduleIndex+"_"+questIndex] == 'undefined') {
                        console.log('not answered',moduleIndex+"_"+questIndex);
                        finished = false;
                    }
                }.bind(this));
                return finished;
            },
            handOverBagde: function(key) {
                if(typeof this.badges[key] != 'undefined') {
                    if(this.badgesReceived.indexOf(key) == -1) {
                        var badgeAlreadyReceived = false;
                        for(var i = 0; i < this.badgesReceived.length; i++) {
                            if(this.badgesReceived[i].key == key) {
                                badgeAlreadyReceived = true;
                            }
                        };
                        if(!badgeAlreadyReceived) {
                            this.xp += this.badges[key].xp;
                            this.badgesReceived.push(this.badges[key]);
                            this.showNewBadges.push(this.badges[key]);
                            window.setTimeout(function() {
                                this.showNewBadgesAnimate = true;
                            }.bind(this),500);
                        }
                    }
                }
                this.storeInLocalStorage();
                return false;
            },
            showBadge: function(key) {
                if(this.badgesReceived.indexOf(key) != -1) {
                    this.showNewBadges.push(this.badges[key]);
                }
            },
            doShowBadges: function() {
                this.showNewBadgesAnimate = false;
                this.showNewBadges.shift();
                window.setTimeout(function() {
                    this.showNewBadgesAnimate = true;
                }.bind(this),500);
                if(!this.showNewBadges.length) {
                    this.showBadges = true;
                }
            }
        },
        updated: function() {
        },
        computed: {
            isHome: function() {
                return this.screen == 'home';
            },
            isInputName: function() {
                return this.screen == 'input-name';
            },
            isGame: function() {
                return this.screen == 'game';
            },
            highestPossibleXP: function() {
                var highest = 0;
                this.hit.map(function(module) {
                    module.quests.map(function(quest) {
                        if(quest.xp) {
                            highest += quest.xp*1;
                        }
                        if(quest.type == "MC" ) {
                            highest += 100;
                        }
                    });
                });
                for(var key in this.badges) {
                    highest += this.badges[key].xp;
                };
                return highest;
            },
            moduleName: function() {
                return this.hit[this.currentModule].name;
            },
            moduleTitle: function() {
                return this.hit[this.currentModule].title?this.hit[this.currentModule].title:this.hit[this.currentModule].name;
            },
            missingModules: function() {
                return new Array(14 - this.hit.length);
            },
            notLastQuest: function() {
                return !this.simpleMode &&  this.currentQuest < this.hit[this.currentModule].quests.length;
            },
            lastQuest: function() {
                return !this.notLastQuest;
            },
            totalXP: function() {
                return this.xp;
            },
            totalScore: function() {
                var total = 0;
                for(var key in this.scores) {
                    if(this.pillars.indexOf(key) == -1 && key != "XP") {
                        total += this.scores[key];
                    }
                }
                return total;
            },
            totalAttributes: function() {
                var total = 0;
                for(var key in this.scores) {
                    if(this.attributes.indexOf(key) != -1 && key != "XP") {
                        total += this.scores[key]
                    }
                }
                return total;
            },
            isMultipleChoice: function() {
                if(!this.hit || this.currentModule < 0 || this.currentQuest < 0) {
                    return;
                }
                return this.hit[this.currentModule].quests[this.currentQuest].type == 'MC';
            },
            isTouch: function() {
                return supportsTouch;
            }
        },
        mounted: function() {
            this.shuffleAnswers();
            document.querySelector('#app').classList.add('loaded');
            if(this.characterName.length >= 5) {
                this.startGame();
            }
            hit.forEach(function(module,moduleIndex) {
                this.badges['MODULE'+moduleIndex] = {
                    key: 'MODULE'+moduleIndex,
                    title: "Modul "+(moduleIndex+1),
                    description: module.name,
                    xp: 1000
                };
            }.bind(this));
            this.loadFromLocalStorage();
            window.setInterval(function() {
                var audios = document.querySelectorAll('audio');
                audios.forEach(function(audio) {
                    var progress = Math.floor(audio.currentTime / audio.duration * 100);
                    audio.parentNode.querySelector('.progress').style.width = progress + '%';
                    var remainingMinutes = Math.floor((audio.duration - audio.currentTime) / 60);
                    var remainingSeconds = Math.floor((audio.duration - audio.currentTime) % 60);
                    audio.parentNode.querySelector('.minutes').innerText = ('00'+remainingMinutes).slice(-2);
                    audio.parentNode.querySelector('.seconds').innerText = ('00'+remainingSeconds).slice(-2);
                });
                var videos = document.querySelectorAll('OFFvideo');
                videos.forEach(function(video) {
                    var progress = Math.floor(video.currentTime / video.duration * 100);
                    video.parentNode.querySelector('.progress').style.width = progress + '%';
                });
            },100);
        }
    }).mount('#app');

    window.ff = ff;


})